module.exports = __webpack_public_path__ + "media/images/svg/logo_light-901107e95576e25c561cbb161053a7bd.svg";